export const StatusCode = {
    Active: "A",
    InActive: "I",
    Delete: "D"
}